import { Box, Flex, Heading, Input, Text, useTheme } from '@homebotapp/hb-react-component-catalog'
import { defineMessages, useIntl } from 'react-intl'
import { HomebotLogoV2 } from './HomebotLogoV2'

export interface WhereAreYouHouseHuntingProps {
  onPlaceSelected: (place: any, placeDetails?: google.maps.places.PlaceResult) => void
  setShowGooglePlaceSelector: (show: boolean) => void
}

const MSG = defineMessages({
  title: {
    id: 'ForYouContent.WhereAreYouHouseHunting.title',
    defaultMessage: 'Where are you house hunting?'
  },
  subtitle: {
    id: 'ForYouContent.WhereAreYouHouseHunting.subtitle',
    defaultMessage: "We're here to help you build wealth with a home you love."
  },
  subtitleBold: {
    id: 'ForYouContent.WhereAreYouHouseHunting.subtitleBold',
    defaultMessage: "Let's get started with a ZIP Code you're interested in!"
  },
  placeholder: {
    id: 'ForYouContent.WhereAreYouHouseHunting.placeholder',
    defaultMessage: 'Enter a place...'
  },
  notSure: {
    id: 'ForYouContent.WhereAreYouHouseHunting.notSure',
    defaultMessage: 'Not sure? Try your current home ZIP'
  },
  enterAPlace: {
    id: 'ForYouContent.WhereAreYouHouseHunting.enterAPlace',
    defaultMessage: 'Enter a place...'
  }
})

export const WhereAreYouHouseHunting = ({ setShowGooglePlaceSelector }: WhereAreYouHouseHuntingProps) => {
  const intl = useIntl()
  const { theme } = useTheme()

  return (
    <Box
      // @ts-ignore - we don't have this color in the design system
      background='linear-gradient(87deg, #220051 16.21%, #31006F 96.43%), #1E1C23'
      p={{ base: 4, md: 8 }}
      borderRadius='lg'
      mb={8}
    >
      <Flex justifyContent='center' flexDirection='column' alignItems='center'>
        <Flex alignItems='center' mb={4} gap={4}>
          <Box borderRadius='full' w={12} h={12} display='flex' alignItems='center'>
            <HomebotLogoV2 />
          </Box>
          <Heading size='lg' mb={0} textAlign='left' color='white'>
            {intl.formatMessage(MSG.title)}
          </Heading>
        </Flex>
        <Flex alignItems='baseline' mb={6} flexWrap='wrap'>
          <Text size='sm' color='white' mr={1}>
            {intl.formatMessage(MSG.subtitle) + ' '}
          </Text>
          <Text size='sm' fontWeight='semibold' color='white'>
            {intl.formatMessage(MSG.subtitleBold)}
          </Text>
        </Flex>

        <Box>
          <Input
            name={intl.formatMessage(MSG.enterAPlace)}
            placeholder={intl.formatMessage(MSG.placeholder)}
            onClick={() => setShowGooglePlaceSelector(true)}
            backgroundColor={theme?.isLightThemeType ? 'neutral.50' : 'unset'}
          />

          <Text size='sm' color={theme?.isLightThemeType ? 'neutral.300' : 'neutral.700'}>
            {intl.formatMessage(MSG.notSure)}
          </Text>
        </Box>
      </Flex>
    </Box>
  )
}
